export const IS_LOGGED_IN_VAR = 'isLoggedInVar'
